import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import { ApproveButton, ButtonWrapper, PendingApprovalLabel } from '../css';
import request from '../../utils/request';

const UserDisabled = ({ email, fetchUsers }) => {
  const [loading, setLoading] = useState(false);

  const handleAction = async () => {
    setLoading(true);
    try {
      const result = await request.put(`/disable-user`, { email, status: 0 });
      if (result) fetchUsers();
    } catch (err) {
      throw err;
    }
  };

  return (
    <Spinner label="Enabling..." show={loading}>
      <PendingApprovalLabel>
        Users profile is disabled. Enable?
      </PendingApprovalLabel>
      <ButtonWrapper>
        <ApproveButton onClick={handleAction}>Enable</ApproveButton>
      </ButtonWrapper>
    </Spinner>
  );
};

UserDisabled.propTypes = {
  email: PropTypes.string.isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export default UserDisabled;
